import React from 'react';
import { Box } from '@mui/material';
import ImageBoxCard from '../../ImageBoxCard/ImageBoxCard';

const CardGrid = ({ data = [], columns = 4, rows = 2, gap = 2, centerIncompleteRow = false }) => {
    const visibleData = data.slice(0, columns * rows);
    const isCentered = data.length < columns; // 👈 center if fewer than 4 items

    if (centerIncompleteRow) {
        const gapPx = typeof gap === "number" ? gap * 8 : 16;
        const maxWidthPx = columns * 250 + (columns - 1) * gapPx;

        return (
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    gap,
                    width: "100%",
                    maxWidth: `${maxWidthPx}px`,
                    my: 4,
                }}
            >
                {visibleData.map((card, i) => (
                    <Box key={i} sx={{ flex: "0 0 250px", display: "flex", justifyContent: "center" }}>
                        <ImageBoxCard
                            title={card.title}
                            img={card.img}
                            href={card.href}
                            onClick={card.onClick}
                        />
                    </Box>
                ))}
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: '1fr',
                    sm: 'repeat(2, 1fr)',
                    md: `repeat(${Math.min(columns, data.length)}, 1fr)`,
                },
                gridAutoRows: 'minmax(250px, auto)',
                gap,
                width: '100%',
                my: 4,
                justifyContent: isCentered ? 'center' : 'flex-start',
                alignItems: isCentered ? 'center' : 'flex-start',
            }}
        >
            {visibleData.map((card, i) => (
                <ImageBoxCard
                    key={i}
                    title={card.title}
                    img={card.img}
                    href={card.href}
                    onClick={card.onClick}
                    state={card.state}
                />
            ))}
        </Box>
    );
};

export default CardGrid;
